import { NotFoundMessage } from '@hendrx/core/common/components/messages/PageMessage/Messages/NotFoundMessage';
import { ServerErrorMessage } from '@hendrx/core/common/components/messages/PageMessage/Messages/ServerErrorMessage';
import { OrganizationsAdminPage } from '@hendrx/core/organizationManagement';
import { createFileRoute } from '@tanstack/react-router';

import { CustomLoadingOverlay } from 'shared/components/app/CustomLoadingOverlay';
import { useUiElementPermissionsQuery } from 'shared/queries/uiElementPermissions';
import { useUser } from 'shared/queries/user';

export const Route = createFileRoute('/studio/organizations')({
  component: OrganizationsAdminPageWrapper
});

function OrganizationsAdminPageWrapper() {
  const { user } = useUser();
  // `isPlaceholderData` matters here: the permissions query serves a placeholder with every flag false
  // while fetching, and gating on it would flash NotFound at a genuine support user.
  const { data: permissions, isError, isLoading, isPlaceholderData } = useUiElementPermissionsQuery(user?.id);

  // A failed permissions read is an error, not "still loading" — after an error the query is no longer
  // pending and `data` stays undefined, so falling through to the overlay would spin forever.
  if (isError) {
    return <ServerErrorMessage />;
  }

  if (isLoading || isPlaceholderData || !permissions) {
    return <CustomLoadingOverlay visible />;
  }

  // The FR-047 support surface, gated on holding BOTH manage capabilities (`canManageOrganizations`). A
  // non-holder sees `NotFoundMessage` — never `/unauthorized`, which would log the user out. The gate is
  // an affordance: every management endpoint re-checks its capability and answers 403 + reason on its own.
  return permissions.canManageOrganizations ? <OrganizationsAdminPage /> : <NotFoundMessage />;
}
